<template>
  <page-status class="report-cert-result">
    <page-result
      :image="content.image"
      :title="content.title"
      :desc="content.desc"
    >
      <div class="result-qrcode">
        <miniapp-qrcode />
      </div>
    </page-result>
  </page-status>
</template>

<script>
import PageStatus from '@/components/PageStatus';
import PageResult from '@/components/PageResult';
import MiniappQrcode from '@/components/MiniappQrcode';
import imgSuccess from '@/assets/img-status-success.png';
import imgError from '@/assets/img-status-error.png';

export default {
  name: 'ReportCertResult',
  components: {
    PageStatus,
    PageResult,
    MiniappQrcode,
  },
  data() {
    return {
      contents: [
        {
          type: 'failure',
          image: imgError,
          title: '链接已经失效',
          desc:
            '欢迎您关注国泰财产保险支付宝小程序，随时获得您的保单情况、理赔进度、赔付情况。',
        },
        {
          type: 'success',
          image: imgSuccess,
          title: '资料上传成功',
          desc:
            '欢迎您关注国泰财产保险支付宝小程序，随时获得您的保单情况、理赔进度、赔付情况。',
        },
      ],
    };
  },
  computed: {
    content() {
      const { type } = this.$route.query;
      const result = this.contents.find(item => item.type === type);
      return result || this.contents[0];
    },
  },
};
</script>

<style lang="less">
.report-cert-result {
  height: 100%;

  .result-qrcode {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
